import { Component, EventEmitter, OnInit, Output, forwardRef } from '@angular/core';
import { SmUiComponent } from '../sm-ui/sm-ui.component';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

@Component({
    selector: 'sm-checkbox',
    templateUrl: './sm-checkbox.component.html',
    styleUrls: ['./sm-checkbox.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmCheckboxComponent),
            multi: true
        }
    ]
})
export class SmCheckboxComponent  extends SmUiComponent implements OnInit {
    @Output() checked = new EventEmitter<any>();
    override ngOnInit(): void {
    }
    checkboxEmitter(event): void {
        this.checked.emit(event.target.checked);
    }

}
